import { useState } from 'react';

interface ShellTerminalProps {
  onSubmit: (command: string) => void | Promise<void>;
  disabled?: boolean;
  placeholder?: string;
}

function ShellTerminal({ onSubmit, disabled = false, placeholder = 'ls -la' }: ShellTerminalProps) {
  const [value, setValue] = useState('');

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) {
      return;
    }
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '0.75rem' }}>
      <label htmlFor="shell-command" style={{ display: 'grid', gap: '0.35rem', fontWeight: 600 }}>
        Command
      </label>
      <textarea
        id="shell-command"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        rows={5}
        placeholder={placeholder}
        disabled={disabled}
        style={{ width: '100%', resize: 'vertical', padding: '0.75rem' }}
      />
      <button type="submit" disabled={disabled || !value.trim()}>
        Submit
      </button>
    </form>
  );
}

export default ShellTerminal;
